import { database } from "../Firebase/FirebaseConfig";
import { ref, get, child } from "firebase/database";

const getProfilePictureUrl = async (email) => {
  const emailKey = email.replace(/\./g, "-").replace("@", "-"); // Replace '.' with '-', Replace '@' with '-'
  try {
    const dbRef = ref(database);
    const snapshot = await get(child(dbRef, `${emailKey}/profile_picture_url`));
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      console.log("No profile picture URL found");
      return null;
    }
  } catch (error) {
    console.error("Error fetching profile picture URL:", error);
    return null;
  }
};

export { getProfilePictureUrl };